// extracted by mini-css-extract-plugin
export default {"neutral90":"#131415","neutral70":"#61656b","neutral30":"#dfe0e2","neutral20Background":"#f4f5f5","neutral10Background":"#f9fafa","primary60Hover":"#153451","secondary50":"#f7921e"};